import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FileText, Image, File, Download } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function FileIcon({ contentType }) {
  if (contentType?.startsWith("image/")) return <Image className="w-5 h-5 text-blue-500" />;
  if (contentType?.includes("pdf")) return <FileText className="w-5 h-5 text-red-500" />;
  return <File className="w-5 h-5 text-zinc-500" />;
}

function formatSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export default function PacketPage() {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "New Member Packet | CHART Networking";
    async function load() {
      try {
        const res = await axios.get(`${API}/packet`);
        setResources(res.data || []);
      } catch { /* */ }
      finally { setLoading(false); }
    }
    load();
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F2EC]">
      <div className="bg-[#0B2A47] text-white">
        <div className="max-w-lg mx-auto px-5 py-8 text-center">
          <img src="/icon-dark.png" alt="" className="h-14 mx-auto mb-3" />
          <h1 className="font-heading text-2xl font-extrabold tracking-tight mb-1">New Member Packet</h1>
          <p className="text-[#8FC4E8] text-sm">Welcome to CHART! Download and review the documents below.</p>
        </div>
      </div>

      <div className="max-w-lg mx-auto px-5 py-8">
        {loading ? (
          <div className="flex justify-center py-12">
            <div className="w-8 h-8 border-4 border-[#1E7BC4] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : resources.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-sm text-[#5A7080]">No documents in the packet yet.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {resources.map(r => (
              <div key={r.resourceId} className="bg-white rounded-xl border border-[#E5E0D8] p-4">
                <div className="flex items-start gap-3">
                  <FileIcon contentType={r.contentType} />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-bold text-[#0B2A47]">{r.title}</p>
                    {r.description && <p className="text-[11px] text-[#5A7080] mt-0.5">{r.description}</p>}
                    <p className="text-[10px] text-[#5A7080] mt-1">{formatSize(r.fileSize)}</p>
                  </div>
                  <a
                    href={`${API}/resources/${r.resourceId}/download`}
                    className="inline-flex items-center gap-1.5 px-4 py-2 text-xs font-bold text-white bg-[#1E7BC4] hover:bg-[#1769A8] rounded-lg transition-colors flex-shrink-0"
                  >
                    <Download className="w-3.5 h-3.5" /> Download
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="mt-8 text-center">
          <Link to="/" className="text-sm font-semibold text-[#1E7BC4] hover:underline">
            ← Back to CHART Home
          </Link>
        </div>
      </div>
    </div>
  );
}
